<template>
  <div>
    <router-view :key="viewKey" />
  </div>
</template>

<script>
const ANALYSIS_ROUTE_NAMES = ["EditAnalysis", "UploadForAnalysis", "EditAnalysisInvoice"];

export default {
  name: "app",
  computed: {
    // Vue reuses the plant and analysis views when only the route params change (plant -> plant,
    // analysis -> analysis), so their created() hook, which loads the data, would not run again
    // and the old plant or analysis stays on screen.
    // Only the plant id belongs in the key: the plant view rewrites its own "result" query
    // (e.g. selecting the latest analysis after opening /plant/:id), which must not remount it.
    viewKey() {
      if (this.$route.name === "Plant") {
        return `plant-${this.$route.params.id}`;
      }

      // Only the analysis id: the tabs rewrite the hash, which must not remount the view
      return ANALYSIS_ROUTE_NAMES.includes(this.$route.name) ? `analysis-${this.$route.params.id}` : undefined;
    },
  },
};
</script>

<style></style>
